import { render, staticRenderFns } from "./courseListByClass.vue?vue&type=template&id=ab2fc278"
import script from "./courseListByClass.vue?vue&type=script&lang=js"
export * from "./courseListByClass.vue?vue&type=script&lang=js"
import style0 from "./courseListByClass.vue?vue&type=style&index=0&id=ab2fc278&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports